/**
 * Document-grade footer: entity details, registration note, nav, transparency link.
 */
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.brandCol}>
          <div className={styles.brand}>
            <span className={styles.mark} aria-hidden="true" />
            USMEHAR CARE
          </div>
          <p className={styles.tagline}>
            A public, auditable wall of proven help. Every case verified on the ground; every
            rupee accounted for.
          </p>
          <p className={styles.reg}>
            Section 8 Company (registration in progress). All figures in INR.
          </p>
        </div>

        <nav className={styles.linksCol} aria-label="Footer">
          <h4 className={styles.colTitle}>Explore</h4>
          <Link to="/programs">What we do</Link>
          <Link to="/served">Served wall</Link>
          <Link to="/transparency">Transparency report</Link>
          <Link to="/about">About &amp; patron</Link>
          <Link to="/faq">FAQ</Link>
        </nav>

        <div className={styles.linksCol}>
          <h4 className={styles.colTitle}>Get involved</h4>
          <Link to="/get-involved">Ways to help</Link>
          <Link to="/contact?topic=volunteer">Volunteer</Link>
          <Link to="/contact?topic=csr">Partner / CSR</Link>
          <Link to="/donate">Donate</Link>
          <Link to="/contact">Contact &amp; enquiries</Link>
        </div>
      </div>

      <div className={`container ${styles.bottom}`}>
        <span>© {year} USMEHAR CARE. Confidential build.</span>
        <span className={styles.muted}>Built by Adsol Digital</span>
      </div>
    </footer>
  );
}

export default Footer;
